import React, { useEffect } from 'react';
import { string, arrayOf, shape, func } from 'prop-types';
import { Tab } from '@thd-olt-component-react/tab';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { extend } from '@thd-nucleus/data-sources';
import { getTypeTabTitle } from '../Helper';
import { SingleIRG } from './SingleIRG';

export const MultipleTabIRG = ({
  tabs, onClickCategory, onClickNext, onError, setActiveTab
}) => {

  if (tabs.length === 0) {
    return null;
  }
  if (tabs.length === 1) {
    return <SingleIRG tab={tabs[0]} />;
  }
  const onChangeTab = ({ index }) => {
    const opts = {
      tab: tabs[index].name,
      subCategory: null
    };
    setActiveTab(opts);
  };

  return (
    <Tab.Group onChange={onChangeTab}>
      {tabs.filter((tab) => tab?.itemIds?.length).map((tab, index) => {
        return (
          <Tab key={index} onChange>
            <Tab.Title>
              <span>{getTypeTabTitle(tab.name)}</span>
              <span>{' '}({tab.itemIds.length})</span>
            </Tab.Title>
            <Tab.Content>
              {tab.active && (
                <SingleIRG
                  tab={tab}
                  onClickNext={onClickNext}
                  onClickCategory={onClickCategory}
                  onError={onError}
                />
              )}
            </Tab.Content>
          </Tab>
        );
      })}
    </Tab.Group>
  );
};

MultipleTabIRG.dataModel = extend({}, ProductPod);

MultipleTabIRG.propTypes = {
  tabs: arrayOf(shape({
    name: string
  })).isRequired,
  onClickCategory: func,
  onClickNext: func,
  onError: func,
  setActiveTab: func
};

const NOOP = () => {};

MultipleTabIRG.defaultProps = {
  onClickCategory: NOOP,
  onClickNext: NOOP,
  onError: NOOP,
  setActiveTab: NOOP
};
